module.exports = __webpack_public_path__ + "static/media/IMG_1493.4bc6bc3d.JPG";